import React, { useState, useEffect } from "react";
import CustomModal from "../customModal/customModal";
import { Button } from "../../ui";
import { useTheme } from "../context/ThemeContext";
import { SketchPicker } from "react-color";

import { toast } from "react-toastify";
import { useFetchProfilesQuery } from "../../store/api/apiSlice";
const HeaderEdit = () => {
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const { data: profileData } = useFetchProfilesQuery();

  const [isOpen, setIsOpen] = useState(false);
  const { fgColor, bgColor } = useTheme();
  const [header, setHeader] = useState("");
  const [Loading, setLoading] = useState(false);
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedColorBG, setSelectedColorBG] = useState("");
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [isBackgroundColorPicker, setIsBackgroundColorPicker] = useState(false);

  useEffect(() => {
    const storedFgColor = profileData?.user?.customForeground;
    const storedBgColor = profileData?.user?.customBackground;
    const title = profileData?.user?.customText;
    setHeader(title);

    if (storedFgColor) {
      setSelectedColor(storedFgColor);
    } else if (!storedFgColor) {
      setSelectedColor(fgColor);
    }
    if (storedBgColor) {
      setSelectedColorBG(storedBgColor);
    } else if (!storedBgColor) {
      setSelectedColorBG(bgColor);
    }
  }, [profileData]);
  const rgbToHex = (rgb) => {
    const result = rgb.match(/\d+/g);
    if (!result || result.length < 3) return rgb;
    const r = parseInt(result[0]).toString(16).padStart(2, "0");
    const g = parseInt(result[1]).toString(16).padStart(2, "0");
    const b = parseInt(result[2]).toString(16).padStart(2, "0");
    return `#${r}${g}${b}`.toUpperCase();
  };
  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };
  const handleColorChange = (color) => {
    if (isBackgroundColorPicker) {
      setSelectedColorBG(color.hex);
    } else {
      setSelectedColor(color.hex);
    }
  };

  const toggleColorPicker = (isBackground) => {
    setIsBackgroundColorPicker(isBackground);
    setShowColorPicker(!showColorPicker);
  };
  const hexToRgb = (hex) => {
    if (!/^#([0-9A-F]{3}){1,2}$/i.test(hex)) {
      return hex;
    }

    let r = 0,
      g = 0,
      b = 0;

    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
      r = parseInt(hex[1] + hex[2], 16);
      g = parseInt(hex[3] + hex[4], 16);
      b = parseInt(hex[5] + hex[6], 16);
    }
    return `${r}, ${g}, ${b}`;
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const formData = new FormData();
    formData.append("customForeground", hexToRgb(selectedColor));
    formData.append("customBackground", hexToRgb(selectedColorBG));
    formData.append("customText", header);

    for (let [key, value] of formData.entries()) {
    }

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const xAuthToken = token ? token.token : null;

      const response = await fetch(`${baseUrl}/api/auth/update-profile`, {
        method: "PUT",
        headers: {
          "secret-key": secretKey,
          "x-auth-token": xAuthToken,
        },
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();

        toast.success("Profile updated successfully");
        setIsOpen(false);
        setLoading(false);
        window.location.reload();
      } else {
        const errorData = await response.json();

        toast.error(errorData.msg);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <div
       className="header_edit_container"
      >
        <p
          className="HeaderEdit_text HeaderEdit_text_p"
          style={{ color: bgColor }}
        >
          {profileData?.user?.customText ||
            `Welcome ${profileData?.user?.firstName} ${profileData?.user?.lastName} !`}
        </p>
        &nbsp;
        <div>
          <img
            className="responsive-icon"
            onClick={handleOpen}
            style={{ color: "#A82C2C", cursor: "pointer" }}
            src="https://img.icons8.com/material-sharp/24/edit--v1.png"
            alt="edit--v1"
          />
        </div>
      </div>
      <CustomModal isOpen={isOpen} onClose={handleClose}>
        <h3>Customize your way</h3>

        <div className="Header_popup_main">
          <label className="Header_popup_main_label">
            Landing page personal banner
          </label>
          <input
            placeholder="Title"
            type="text"
            name="Title"
            value={header}
            onChange={(e) => setHeader(e.target.value)}
          />
        </div>

        <div className="Header_popup_div" >
          <div className="Header_popup_main">
            <label className="Header_popup_main_label">
              Text Color
            </label>
            <div
              onClick={() => toggleColorPicker(false)}
              className="header_popup_edit"
              style={{
                backgroundColor: rgbToHex(selectedColor),
                
              }}
            />
            <input
              placeholder="Title"
              type="text"
              name="Title"
              value={selectedColor}
              onChange={(e) => setSelectedColor(e.target.value)}
            />
          </div>
          <div className="Header_popup_main">
            <label className="Header_popup_main_label">
              Background & banner color
            </label>
            <div
              onClick={() => toggleColorPicker(true)}
              className="header_popup_edit"
              style={{
                backgroundColor: rgbToHex(selectedColorBG),
               
              }}
            />
            <input
              placeholder="Title"
              type="text"
              name="Title"
              value={selectedColorBG}
              onChange={(e) => setSelectedColorBG(e.target.value)}
            />
          </div>
        </div>
        {showColorPicker && (
          <div className="header_popup_clrPicker">
            <SketchPicker
              color={isBackgroundColorPicker ? selectedColorBG : selectedColor}
              onChangeComplete={handleColorChange}
            />
          </div>
        )}
        <div
          className="header_popup_btnDiv"
        >
          <Button outlined onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={handleAddSubmit}>Save</Button>
        </div>
      </CustomModal>
    </>
  );
};

export default HeaderEdit;
